<template>
	<div class="consultation-modal">
		<div class="consultation-modal.mask" v-show="consultationShow">
			<div class="consultation-modal.container">
				<div class="consultation-modal.header">
					<img src="../assets/evalution/tel.png" alt="">
					<span>热线咨询电话：</span>
					<h3>0931-8358767</h3>
				</div>
				<div class="consultation-modal.close" @click="closeConsultation">
					<img src="../assets/evalution/close.png" alt="">
				</div>
				<div class="consultation-modal.form">
					<el-form ref="consultationForm" :model="consultationForm" :rules="consultationFormRules"  label-width="100px">
						<el-form-item label="您的需求:" prop="desc">
							<el-input type="textarea" v-model="consultationForm.desc"></el-input>
						</el-form-item>
						<el-form-item label="联系方式:" prop="phone">
							<el-input v-model="consultationForm.phone"></el-input>
						</el-form-item>
						<el-form-item class="consultation-modal.button">
							<el-button type="primary" @click="onSubmit">提交需求</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<tips-modal :tipsShow="tipsShow" @closeTipsEvent="closeTipsEvent"></tips-modal>
	</div>
</template>

<script>
	  import TipsModal from '../components/tips-modal.vue'
	  import '../fetch/formatDate';
	  import checkPhone from '../fetch/checkPhone';
	 export default {
		props: ['consultationShow'],
		components:{
			TipsModal
		},
		data() {
			return {
				tipsShow:false,
				consultationForm: {
					desc: '',
					phone: ''
				},
				consultationFormRules: {
					desc: [{
						required: true,
						message: '请填写需求',
						trigger: 'blur'
					}],
					phone: [
						{validator: checkPhone, trigger: 'blur',required: true,}
					]
				
				}
			}
		},
		methods: {
			showScroll() {
				document.body.style.removeProperty('overflow-y')
				document.body.style.removeProperty('position')
			},
			hideScroll() {
				document.body.style.position = 'fixed'
				document.body.style.overflowY = 'hidden'

			},
			closeConsultation(){
				this.$emit('closeConsultationEvent', false)
				this.$refs['consultationForm'].resetFields();
			},
			onSubmit(){
				this.$refs['consultationForm'].validate((valid) => {
					if (valid) {
						this.http.post('IPR_Need',{
							  content: this.consultationForm.desc,
							  phone :this.consultationForm.phone,
							  type: 6, //商品服务咨询
							  name:'商品服务咨询测试人员' ,
							  date_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
						}).then(res => {
							if(res.code == 0){
								this.$emit('closeConsultationEvent', false)
								this.tipsShow = true
								this.$refs['consultationForm'].resetFields();
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeTipsEvent(val){
				console.log(val)
				this.tipsShow = val
			}
		},
		// watch: {
		// 	tipsShow: {
		// 		handler(newVal, oldVal) {
		// 			if(newVal){
		// 				//this.hideScroll()
		// 				
		// 			}else{
		// 				//this.showScroll()
		// 			}
		// 			
		// 		},
		// 		deep: true,
		// 		immediate: true
		// 	},
		// },

	}
</script>

<style lang="scss">
	@include component(consultation-modal) {
	    @include part(mask){
			width: 100%;
			min-width: $minWidth;
			height: 100vh;
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			background: rgba(0, 0, 0, 0.2);
			z-index: 9999999;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #333333;
			
		}

		@include part(container) {
			width: 400px;
			height: 300px;
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
			border-radius: 10px;
			background-color: #ffffff;
			position: relative;

			&:before {
				content: '';
				display: inline-block;
				width: 370px;
				height: 60px;
				background: url(../assets/evalution/3d-bg.png);
				position: absolute;
				top: -20px;
				left: 15px;
				z-index: -1;
			}
		}

		@include part(header) {
			width: 312px;
			height: 50px;
			border-radius: 10px;
			background-color: #f47227;
			position: absolute;
			left: calc((100% - 312px) / 2);
			top: -20px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #FFFFFF;
			font-size: 16px;
			letter-spacing: -0.8px;
			padding: 0 10px;

			img {
				width: 23px;
				height: 27px;
				display: block;
			}

			span {
				display: inline-block;
				margin-left: 8px;
			}

			h3 {
				margin: 0;
				font-size: 24px;
				font-weight: normal;
				letter-spacing: -1.2px;
			}
		}

		@include part(close) {
			width: 40px;
			height: 40px;
			position: absolute;
			right: -15px;
			top: -15px;
			cursor: pointer;
		}

		@include part(form) {
			margin-top: 60px;
			width: 100%;
			padding: 0 40px;
		}

		@include component(el-button) {
			width: 100%;
			background: #F47227;
			border: none;
		}
		@include component(el-form-item__content){
			display: flex;
			justify-content: center;
			margin-left: 0 !important;
		}
		@include component(el-button){
			width: 70%;
		}
		@include part(button){
			margin-top: 54px;
		}

		@include component(el-button--primary) {
			background-color: #F47227;

			&:active,
			&:hover,
			&:focus {
				background-color: #F47227;
			}

			&.is-active {
				background-color: #F47227;
			}
		}
	}
</style>
